import type { CSSProperties } from 'react'
import type { Segments } from '../../lib/segments'

// The hero stat (ux/03 Header): the number is the design. Condensed Archivo
// 800, tabular, beside (phone) or above (desktop) a tracked caps label, with
// a segmented bar under it (lib/segments.ts): a pill per item on a short
// list, one continuous bar on a long one.

export function Hero({ count, label, layout, info, children }: {
  count: number
  label: string
  layout: 'phone' | 'desktop'
  /** An (i) beside the label (InfoButton), for how this page works. */
  info?: React.ReactNode
  children?: React.ReactNode
}) {
  return (
    <div className={`ml-hero ml-hero--${layout}`}>
      <div className="ml-hero__stat">
        <span className="ml-hero__num ml-num" aria-hidden="true">{count}</span>
        <span className="ml-label ml-hero__label">{label}</span>
        {info}
        <span className="ml-visually-hidden">{`${count} ${label.toLowerCase()}`}</span>
      </div>
      {children}
    </div>
  )
}

export function SegmentBar({ segments, label }: { segments: Segments<boolean | string>; label: string }) {
  if (!segments.parts.length) return null
  return (
    <div className={`ml-segments${segments.bar ? ' ml-segments--bar' : ''}`} role="img" aria-label={label}>
      {segments.parts.map(({ fill, weight }, i) => (
        <span key={i}
          className={`ml-segment${fill === true ? ' is-filled' : ''}`}
          style={{
            flexGrow: weight,
            ...(typeof fill === 'string' ? { '--ml-tint': fill, background: 'var(--ml-tint)' } : {}),
          } as CSSProperties} />
      ))}
    </div>
  )
}
